import axios from "axios";

// Feature flag for logging
const DEBUG_LOGGING = process.env.REACT_APP_DEBUG_LOGGING === 'true';

const log = (message, ...args) => {
	if (DEBUG_LOGGING) {
		console.log(message, ...args);
	}
};

const logError = (message, ...args) => {
	if (DEBUG_LOGGING) {
		console.error(message, ...args);
	}
};

const logWarn = (message, ...args) => {
	if (DEBUG_LOGGING) {
		console.warn(message, ...args);
	}
};

// Dinamički odaberi API URL ovisno o okruženju
const getApiUrl = () => {
	// Ako je eksplicitno postavljena env varijabla, koristi je
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}

	// Ako je localhost, koristi localhost backend
	if (
		window.location.hostname === "localhost" ||
		window.location.hostname === "127.0.0.1"
	) {
		return "http://localhost:8000";
	}

	// Na produkciji, koristi isti domain kao frontend
	return window.location.protocol + "//" + window.location.hostname;
};

const BACKEND_URL = getApiUrl();

log("🔧 API URL:", BACKEND_URL);
log("🌍 Current hostname:", window.location.hostname);
log("📦 REACT_APP_API_URL from .env:", process.env.REACT_APP_API_URL);

const setup = axios.create({
	baseURL: `${BACKEND_URL}/api`,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
});

// Request interceptor - dodaj token
setup.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("access_token");
		log(
			"📤 Request:",
			config.method.toUpperCase(),
			config.url,
			"Token:",
			token ? token.substring(0, 20) + "..." : "NEMA",
		);

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		logError("❌ Request error:", error);
		return Promise.reject(error);
	},
);

// Response interceptor - handle errors
setup.interceptors.response.use(
	(response) => {
		log("✅ Response OK:", response.status, response.config.url);
		return response;
	},
	(error) => {
		logError("❌ Response error:", {
			status: error.response?.status,
			url: error.response?.config?.url,
			data: error.response?.data,
			message: error.message,
		});

		if (error.response?.status === 401) {
			logWarn(
				"🚪 Unauthorized - Čišćenje tokena i redirect na login",
			);
			localStorage.removeItem("access_token");
			localStorage.removeItem("token");
			delete setup.defaults.headers.common.Authorization;
			window.location.href = "/login";
		}

		return Promise.reject(error);
	},
);

export default setup;
